import { BookEnum } from '@interfaces/BookEnum'
import { Expose, Transform } from 'class-transformer'

export class WriterSalesAnalyticsOverviewEbookDataType {
  @Expose()
  @Transform(({ value }) => value || undefined)
  ebookTitle?: string

  @Expose()
  @Transform(({ value }) =>
    value === BookEnum.MANGA
      ? 'การ์ตูน'
      : value === BookEnum.NOVEL
      ? 'นิยาย'
      : undefined
  )
  ebookType?: string

  @Expose() purchasedCount: number

  @Expose() readTrialChapterCount: number

  @Expose() sales: number

  @Expose() viewCount: number
}
